import { httpClient } from './httpClient';

const base = '/api/estudiantes';

export const buscarEstudiantes = (term = '') => {
  const query = term ? `?search=${encodeURIComponent(term)}` : '';
  return httpClient.get(`${base}/buscar${query}`);
};

export const buscarInscritos = (term = '') => {
  const query = term ? `?search=${encodeURIComponent(term)}` : '';
  return httpClient.get(`${base}/buscar-inscritos${query}`);
};

export const buscarPorDocumento = (documento = '') => {
  const query = new URLSearchParams({ documento }).toString();
  return httpClient.get(`${base}/buscar-documento?${query}`);
};

export const listarEstudiantes = (params = {}) => {
  const entries = Object.entries(params).filter(([, v]) => v !== null && v !== undefined && v !== '' && v !== 'all');
  const qs = new URLSearchParams(entries.map(([k, v]) => [k, String(v)])).toString();
  return httpClient.get(`${base}${qs ? `?${qs}` : ''}`);
};
export const obtenerEstudiante = (id) => httpClient.get(`${base}/${id}`);
export const crearEstudiante = (payload) => httpClient.post(base, payload);
export const actualizarEstudiante = (id, payload) => httpClient.put(`${base}/${id}`, payload);
export const actualizarEducacionGeneral = (estudianteId, educacionId, payload) =>
  httpClient.put(`${base}/${estudianteId}/educacion-general/${educacionId}`, payload);
export const eliminarEducacionGeneral = (estudianteId, educacionId) =>
  httpClient.del(`${base}/${estudianteId}/educacion-general/${educacionId}`);
export const actualizarExperienciaGeneral = (estudianteId, experienciaId, payload) =>
  httpClient.put(`${base}/${estudianteId}/experiencia-general/${experienciaId}`, payload);
export const eliminarExperienciaGeneral = (estudianteId, experienciaId) =>
  httpClient.del(`${base}/${estudianteId}/experiencia-general/${experienciaId}`);
export const agregarVehiculoEstudiante = (estudianteId, payload) =>
  httpClient.post(`${base}/${estudianteId}/vehiculos`, payload);
export const eliminarVehiculoEstudiante = (estudianteId, vehiculoId) =>
  httpClient.del(`${base}/${estudianteId}/vehiculos/${vehiculoId}`);
export const agregarLicenciaEstudiante = (estudianteId, payload) =>
  httpClient.post(`${base}/${estudianteId}/licencias`, payload);
export const eliminarLicenciaEstudiante = (estudianteId, licenciaId) =>
  httpClient.del(`${base}/${estudianteId}/licencias/${licenciaId}`);
export const asignarReferente = (id, referente_id) =>
  httpClient.put(`${base}/${id}/referente`, { referente_id });
export const eliminarEstudiante = (id) => httpClient.del(`${base}/${id}`);
export const obtenerCatalogosEstudiantes = () => httpClient.get(`${base}/catalogos`);

const estudiantesService = {
  buscar: buscarEstudiantes,
  buscarPorDocumento,
  buscarInscritos,
  listar: listarEstudiantes,
  obtener: obtenerEstudiante,
  crear: crearEstudiante,
  actualizar: actualizarEstudiante,
  actualizarEducacionGeneral,
  eliminarEducacionGeneral,
  actualizarExperienciaGeneral,
  eliminarExperienciaGeneral,
  eliminar: eliminarEstudiante,
  catalogos: obtenerCatalogosEstudiantes,
  campusReset: (id) => httpClient.post(`/api/estudiantes/${id}/campus-reset`, {}),
};

export default estudiantesService;
